<% var visit_type = validated_visit_types.find(function(visit_type) { return visit_type.id == validated_visit_type_id }) %>

<div class="message message-warning">
  <% var providerSwitch = I18n.messages.provider_switch %>
  <% if (validated_ehr_appointment_slot_id) { %>
    <p><%= providerSwitch.switched_html.replace('%{provider}', validated_provider.name) %></p>
    <p><%= providerSwitch.contact_us_html.replaceAll('%{phone_number}', I18n.help_phone_number) %></p>
  <% } else if (visit_type && visit_type.suggested_slots && visit_type.suggested_slots.length) { %>
    <p><%= providerSwitch.not_pcp_contact_html.replaceAll('%{phone_number}', I18n.help_phone_number) %></p>
    <p><%= providerSwitch.suggested_times_html.replace('%{provider}', validated_provider.name) %></p>
  <% } else if (validated_visit_types.length) { %>
    <p><%= providerSwitch.not_pcp %></p>
    <p><%= providerSwitch.unavailable_for_visit_type.replace('%{visit_type}', appointment_slot.visit_type_name) %></p>
    <p><%= providerSwitch.please_contact_html.replaceAll('%{phone_number}', I18n.help_phone_number) %></p>
  <% } else { %>
    <p><%= providerSwitch.not_pcp %></p>
    <p>
      <%= providerSwitch.no_online_appointments.replace('%{provider}', validated_provider.name) %>
      <% if (validated_address.phone_number) { %>
        <%= providerSwitch.call_office_html.replaceAll('%{phone_number}', validated_address.phone_number) %>
      <% } %>
    </p>
    <p><%= providerSwitch.contact_us_html.replaceAll('%{phone_number}', I18n.help_phone_number) %></p>
  <% } %>
</div>
